import React from 'react';
import { FormattedMessage } from 'react-intl';

import style from './default-placeholder.module.less';

export const DefaultPlaceholder = () => {
  return (
    <div className={style['default-placeholder']}>
      <div className={style['placeholder-content']}>
        <div className={style['placeholder-message']}>
          <FormattedMessage defaultMessage='No data in the grid' description='defaultPlaceholder.noDataInGrid' id='gwZYHb' />
        </div>
      </div>
    </div>
  );
};
